import axios from "axios";

const baseUrl = import.meta.env.VITE_API_URL;

const clientBillingApi = axios.create({
  baseURL: baseUrl,
});

clientBillingApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("clientToken") ?? "";
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default clientBillingApi;
